<template>
  <div>

    <!--blog Section start-->
    <div class="page-margin">


      <!-- sign in -->
      <FaqInfo/>

      <RecallForm/>
      <!-- sign up -->
      <!--blog Section end-->
    </div>
    <Map/>
    <!--Footer Section start-->
    <Footer/>
    <js/>
    <!--Footer Section End-->
  </div>
</template>
<script>

  export default {
    name: 'Faq'
  }
</script>



// WEBPACK FOOTER //
// src/pages/faq_page.vue